import { reduxForm } from 'redux-form';
import Joi from 'joi-full';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import Form from '../components/SubscriptionPlanForm';
import { syncValidateData } from '../../../common/validator';
import withNotifications from '../../../common/withNotifications';
import { t } from '../../../../modules/infra/i18n';

const FORM = 'subscriptionPlanForm';

const schema = Joi.object().keys({
  name: Joi.string().min(2).required(),
  extraFeatures: Joi.boolean().optional().allow(null),
  customApp: Joi.boolean().optional().allow(null),
  campaignsEnabled: Joi.boolean().optional().allow(null),
  commissionReportingEnabled: Joi.boolean().optional().allow(null),
  productReportingEnabled: Joi.boolean().optional().allow(null),
  customReportingEnabled: Joi.boolean().optional().allow(null),
  chatEnabled: Joi.boolean().optional().allow(null),
  conversionTracking: Joi.boolean().optional().allow(null),
});

const validate = data => syncValidateData(data, schema);

const form = reduxForm({
  form: FORM,
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.addNotification({
      title: t('subscription:form.success_title'),
      level: 'success',
      message: props.initialValues.id 
        ? t('subscription:form.update_success_message')
        : t('subscription:form.create_success_message'),
    });
    props.router.replace('/admin/subscription/plans');
  },
  enableReinitialize: true,
  validate,
});


const getInitialValues = (data = {}) => {
  if (!data.id) {
    return {
      customApp: false,
      extraFeatures: false,
      campaignsEnabled: false,
      conversionTracking: false,
      commissionReportingEnabled: false,
      productReportingEnabled: false,
      customReportingEnabled: false,
      chatEnabled: false,
    };
  }

  return data;
};

export default compose(
  withRouter,
  withNotifications,
  withProps(props => ({
    initialValues: getInitialValues(props.initialValues),
  })),
  form
)(Form);
